import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getSoldProducts } from "../../../actions/invoiceItem";
import { getAllLocation, getAllLocationPlain } from "../../../actions/warehouseAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllBrand } from "../../../actions/Inventory/brandAction";
import ReactToPrint from "react-to-print";
import dateFormat from "dateformat";
import Excelldownload from "./Excelldownload";
import { Divider, AutoComplete, Row, Col, Select, Skeleton, Button, Layout, DatePicker, Spin, Breadcrumb, Alert, TreeSelect } from "antd";

const { RangePicker } = DatePicker;
const { Content } = Layout;
const { Option } = Select;

const SoldPorduct = ({
  getSoldProducts,
  getAllLocation,
  getAllLocationPlain,
  businessprofile,
  Auth,
  getAllCategory,
  getAllBrand,
  categoryList,
  brandList,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setloading] = useState(false);
  const [initial, setinitial] = useState(false);
  const [reload, setreload] = useState(false);
  const [profitLoss, setProfitLoss] = useState(0);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const category = useRef("");
  const brand = useRef("");
  
  
  const location = useRef("");
  const start = useRef("");
  const end = useRef("");
  const keyward = useRef("");
  const total_quantity = useRef(0);
  const total_amount = useRef(0);
  const total_purchase_amount = useRef(0);
  const flag = useRef(0);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      keyward.current = event.target.value;
    }
  };

  const groupByInvoiceNo = (data) => {
    return data.reduce((acc, item) => {
      if (!acc[item.Invoice_no]) {
        acc[item.Invoice_no] = [];
      }
      acc[item.Invoice_no].push(item);
      return acc;
    }, {});
  };

  useEffect(() => {
    total_quantity.current = 0;
    total_amount.current = 0;
    total_purchase_amount.current = 0;
    if (flag.current != 0) {
      getAllLocationPlain().then((res) => {
        setLocations(res);
        getSoldProducts(
          keyward.current,
          start.current,
          end.current,
          location.current,
          "",
          category.current,
          brand.current
        ).then((result) => {
          total_quantity.current = 0;
          total_amount.current = 0;
          total_purchase_amount.current = 0;
          setData(result);
          setloading(false);
          
          // Calculate profit/loss after data is loaded
          calculateProfitLoss(result);
        });
      });
    } else {
      setinitial(true);
      getAllLocationPlain().then((res) => {
        setLocations(res);
        setinitial(false);
      });
      getAllCategory().then((res) => {
        setCategories(res);
        setinitial(false);
      });
      getAllBrand().then((res) => {
        setBrands(res);
        setinitial(false);
      });
    }
  }, [reload]);

  const calculateProfitLoss = (result) => {
    let totalSales = 0;
    let totalPurchase = 0;
    
    result.forEach((item) => {
      totalSales += parseInt(item.quantity * item.price);
      totalPurchase += parseInt(item.quantity * item.purchase_price);
    });
    
    const calculatedProfitLoss = totalSales - totalPurchase;
    setProfitLoss(calculatedProfitLoss);
  };

  const groupedData = groupByInvoiceNo(data);

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
        <Breadcrumb.Item>Sold Products Report</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row wrap={false}>
          <Col flex="auto">
            <h3>Search by</h3>
            <AutoComplete
              placeholder="product name, barcode, invoice number"
              onKeyUp={onChange}
              style={{ width: "100%", minWidth: "130px" }}
            />
          </Col>
          <Col flex="auto">
            <h3>Issue date :</h3>
            <RangePicker
              style={{ width: "100%" }}
              picker="date"
              onChange={(value) => {
                if (value) {
                  start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                  end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                }
              }}
            />
          </Col>
          <Col flex="auto">
            <h3>Choose Location</h3>
            <Select
              placeholder="Select Location"
              style={{ width: "100%" }}
              disabled={
                Auth.superuser ||
                Auth.profile.user_role.id == 10 ||
                Auth.profile.user_role.id == 36 ||
                Auth.profile.user_role.id == 38
                  ? false
                  : true
              }
              onChange={(e) => {
                location.current = e;
                // setloading(true);
                // setreload(!reload);
              }}
            >
              <Option value="">All</Option>
              {locations.map((outlet) => {
                return <Option value={outlet.id}>{outlet.name}</Option>;
              })}
            </Select>
          </Col>
          {/* <Col flex="auto">
            <h3>Choose Category</h3>
              <TreeSelect
                showSearch
                allowClear
                treeNodeFilterProp="title"
                style={{ width: "100%" }}
                treeData={categoryList}
                onChange={(value) => {
                  category.current = value;
                  
                }}
              />
          </Col> */}
          <Col flex="auto">
            <h3>Choose Brand</h3>
              <Select
                placeholder="Select Brand"
                style={{ width: "100%" }}
                  allowClear
                optionFilterProp="children"
                showSearch
                filterOption={(input, option) =>
                  ((option && option.children) ? option.children.toLowerCase() : '')
                    .includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) =>
                  ((optionA && optionA.children) ? optionA.children.toLowerCase() : '')
                    .localeCompare(
                      (optionB && optionB.children) ? optionB.children.toLowerCase() : ''
                    )
                }
                onChange={(value) => {
                  brand.current = value;
                  setloading(true);
                  setreload(!reload);
                }}
              >
                <Option value="">All</Option>
                {brandList.map((brand) => (
                  <Option key={brand.id} value={brand.id}>
                    {brand.name}
                  </Option>
                ))}
              </Select>
          </Col>
          <Col flex="auto">
            <h3>.</h3>
            <Button type="primary" style={{ width: "100%", marginRight: "4px", backgroundColor: "#ab0735" }} onClick={() => {
              flag.current = 1;
              setloading(true);
              setreload(!reload);
            }}>Search</Button>
          </Col>
          <Col flex="auto">
            <h3>.</h3>
            <Excelldownload data={data} />
          </Col>
          <Col flex="auto">
            <h3>.</h3>
            <ReactToPrint
              trigger={() => (
                <Button style={{ marginLeft: "2px", width: "100%" }} type="primary">
                  PDF
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Col>
        </Row>
        
        {/* Profit/Loss Display */}
        {flag.current !== 0 && data.length > 0 && (
          <Row style={{ marginTop: "16px" }}>
            <Col span={24}>
              <Alert
                message={
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {profitLoss > 0 ? "Profit" : profitLoss < 0 ? "Loss" : "Break Even"}: {formatter.format(Math.abs(profitLoss))} BDT
                  </span>
                }
                type={profitLoss > 0 ? "success" : profitLoss < 0 ? "error" : "info"}
                showIcon
              />
            </Col>
          </Row>
        )}
        
        <Divider />
        <Spin spinning={loading}>
          <div ref={componentRef} style={{ padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>Sold Products Report</h2>
            <Row>
              <Col span={12} style={{ textAlign: "left" }}>
                {start.current != "" ? (
                  <>
                    From : {dateFormat(start.current, "mmmm dS, yyyy")}
                    <br></br>
                  </>
                ) : (
                  ""
                )}
                {end.current != "" ? (
                  <>
                    To : {dateFormat(end.current, "mmmm dS, yyyy")}
                    <br></br>
                  </>
                ) : (
                  ""
                )}
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                {locations.map((outlet) => {
                  if (outlet.id == location.current)
                    return <>Outlet : {outlet.name}</>;
                })}
              </Col>
            </Row>
            <br></br>
            <table className="attendacne_table" style={{ width: "100%", textAlign: "center" }}>
              <thead>
                <tr style={{ background: "#FAFAFA" }}>
                  <th>SL.</th>
                  <th>Date</th>
                  <th>Invoice</th>
                  <th>Customer Contact</th>
                  <th>Category</th>
                  <th>Title</th>
                  <th>Brand</th>
                  <th>Size</th>
                  <th>QTY</th>
                  <th>Batch</th>
                  <th>Purchase Price / pcs</th>
                  <th>Selling Price / pcs</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(groupedData).map((invoiceNo, index) => {
                  const items = groupedData[invoiceNo];
                  console.log(items)
                  return items.map((item, i) => {
                    let product = item.Details.split("--");
                    console.log(product)
                    total_quantity.current += parseInt(item.quantity);
                    total_amount.current += parseInt(item.quantity * item.price);
                    total_purchase_amount.current += parseInt(item.quantity * item.purchase_price);
                    let product_details = "";
                    let color = "";
                    let size = "";
                    if (product.length > 1) {
                      product_details = product[1].split("/");
                      color = product_details[0];
                      size = product_details.length > 1 ? product_details[1] : "";
                    }
                    return (
                      <tr key={`${invoiceNo}-${i}`}>
                        {i === 0 ? (
                          <>
                            <td rowSpan={items.length}>{index + 1}</td>
                            <td rowSpan={items.length}>{item.issue_date}</td>
                            <td rowSpan={items.length}>{item.Invoice_no}</td>
                            <td rowSpan={items.length}>{item.Contact}</td>
                          </>
                        ) : null}
                        <td>{item.main_category}</td>
                        <td>{product[0]}</td>
                        <td>{item.brand_name}</td>
                        <td>{color}</td>
                        <td>{item.quantity}</td>
                        <td>{item.batch_no}</td>
                        <td>{item.purchase_price}</td>
                        <td>{item.price}</td>
                      </tr>
                    );
                  });
                })}
                <tr style={{ background: "#FAFAFA" }}>
                  <td colSpan={8}><b>Total</b></td>
                  <td><b>{total_quantity.current}</b></td>
                  <td colSpan={1}></td>
                  <td><b>{total_purchase_amount.current}</b></td>
                  <td><b>{total_amount.current}</b></td>
                </tr>
                {/* <tr style={{ background: profitLoss > 0 ? "#f6ffed" : profitLoss < 0 ? "#fff1f0" : "#f0f0f0" }}>
                  <td colSpan={6}><b>{profitLoss > 0 ? "Profit" : profitLoss < 0 ? "Loss" : "Break Even"}</b></td>
                  <td colSpan={5}><b style={{ color: profitLoss > 0 ? "#52c41a" : profitLoss < 0 ? "#ff4d4f" : "#000" }}>{Math.abs(profitLoss)}</b></td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </Spin>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    Auth: state.auth,
    categoryList: state.category.categorylist,
    brandList: state.brand.brandlist,

  };
};

export default connect(mapStateToProps, {
  getSoldProducts,
  getAllLocationPlain,
  getAllLocation,
  getAllCategory,
  getAllBrand,
})(SoldPorduct);